import React, { useState, useEffect, useContext } from "react";
import { BlogDataEs, BlogDataEn } from "../assets/info/blog.js";
import LanguageContext from "../context/langContext.js";
import { BlogCardsPrevGenerator } from "../components/pure/blogCardGenerator.jsx";
import { useNavigate } from "react-router-dom";
import telegram from "../assets/img/blog/telegrama.png";
import discord from "../assets/img/blog/discord.png";
import { Helmet } from "react-helmet";
import CardPrevBlog from "../components/pure/cardPrevBlog.jsx";

export default function Blog() {
  const { lang, setLang } = useContext(LanguageContext);
  const [text, setText] = useState(BlogDataEn);
  const navigate = useNavigate();
  let cadenaEntrada;

  useEffect(() => {
    if (lang == "en") {
      setText(BlogDataEn);
    } else if (lang == "es") {
      setText(BlogDataEs);
    } else {
      setText(BlogDataEn);
    }
  }, [lang]);

  function navegateTo(index) {
    let title = text[index]["url"];
    navigate(title);
  }

  let lastCard = text.length - 1;

  return (
    <div className="blogPage">
      <Helmet>
        <title>Analysis Software For Volume and Delta</title>
        <meta
          name="description"
          content="Optimiza tu estrategia de trading en el mercado de futuros con OTM Trading, el software de indicadores técnicos especializado en volumen y delta que te brinda información precisa y confiable."
        />
      </Helmet>

      <h2 className="blogPage__title">OTM Blog</h2>
      <div className="blogPage__container">
        <div className="blogPage__cards">
          <div className="blogPage__cards--card" key={lastCard}>
            {Object.keys(text[lastCard]).map((key, index) => {
              return (
                <BlogCardsPrevGenerator
                  key={index}
                  i={key}
                  data={text[lastCard][key]}
                  navegateTo={navegateTo}
                  indexCard={lastCard}
                ></BlogCardsPrevGenerator>
              );
            })}
          </div>
        </div>

        <div className="blogPage__aside">
          <a
            className="blogPage__aside--link"
            href="https://link.com"
            target="_blank"
          >
            <img className="blogPage__aside--link--img" src={telegram} />
            <p className="blogPage__aside--link--txt">
              Join our
              <br /> Telegram Channel
            </p>
          </a>

          <a
            className="blogPage__aside--link blogPage__aside--linkDisc"
            href="https://link.com"
            target="_blank"
          >
            <img className="blogPage__aside--link--img" src={discord} />
            <p className="blogPage__aside--link--txt">
              Join our
              <br /> Discord Channel
            </p>
          </a>
        </div>
      </div>

      <div className="blogPage__prev">
            {text.map((card,i)=>(
              <CardPrevBlog 
              key={i}
              index={i}
              card={card}
              ></CardPrevBlog>
 
            ))}

      </div>



    </div>
  );
}
